import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { Instagram, MapPin, Phone } from 'lucide-react';
import { motion } from 'framer-motion';
import Logo from './Logo';

const Footer: React.FC = () => {
  const { t } = useTranslation();

  return (
    <footer className="bg-black text-gray-300 py-20 relative">
      <div className="section-padding relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          <div>
            <div className="flex items-center gap-3 mb-6">
              <Logo width={48} height={48} />
              <h3 className="text-3xl font-display">
                ROYAL <span className="text-koi-red">O'NARA</span>
              </h3>
            </div>
            <p className="text-base text-gray-400 mb-6 font-body">{t('hero.subtitle')}</p>
            <div className="flex gap-4">
                              <motion.a
                  whileHover={{ scale: 1.1 }}
                  href="https://www.instagram.com/royal_onara"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-block"
                >
                  <svg width="34" height="34" viewBox="0 0 24 24" fill="none" stroke="url(#instagram-gradient)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <defs>
                      <linearGradient id="instagram-gradient" x1="0%" y1="0%" x2="100%" y2="100%">
                        <stop offset="0%" stopColor="#833AB4" />
                        <stop offset="50%" stopColor="#FD1D1D" />
                        <stop offset="100%" stopColor="#FCAF45" />
                      </linearGradient>
                    </defs>
                    <rect x="2" y="2" width="20" height="20" rx="5" ry="5"></rect>
                    <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"></path>
                    <circle cx="17.5" cy="6.5" r="0.5" fill="url(#instagram-gradient)"></circle>
                  </svg>
                </motion.a>
            </div>
          </div>

          <div>
            <h4 className="text-xl font-display mb-6 text-white">{t('nav.menu')}</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="text-base text-gray-400 hover:text-koi-red transition-colors duration-300 font-body">
                  {t('nav.home')}
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-base text-gray-400 hover:text-koi-red transition-colors duration-300 font-body">
                  {t('nav.about')}
                </Link>
              </li>
              <li>
                <Link to="/menu" className="text-base text-gray-400 hover:text-koi-red transition-colors duration-300 font-body">
                  {t('nav.menu')}
                </Link>
              </li>
              <li>
                <Link to="/location" className="text-base text-gray-400 hover:text-koi-red transition-colors duration-300 font-body">
                  {t('nav.location')}
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-xl font-display mb-6 text-white">{t('nav.contact')}</h4>
            <div className="space-y-4 text-base text-gray-400 font-body">
              <p className="flex items-start gap-2">
                <MapPin className="mt-1 flex-shrink-0" size={29} />
                <span>
                  4 Rue Willy Bandt<br />
                  25300 Pontarlier, France
                </span>
              </p>
              <p className="flex items-center gap-2">
                <Phone size={29} />
                <a href="tel:0381895950" className="hover:text-koi-red transition-colors duration-300">
                  03 81 89 59 50
                </a>
              </p>
            </div>
          </div>
        </div>

        <div className="h-px bg-koi-red/20 my-12" />

        <div className="text-center">
          <p className="text-gray-500 text-sm font-body tracking-wide">
            &copy; 2024 Royal O'Nara • {t('info.open7days')}
          </p>
          <div className="text-gray-500 text-sm font-body tracking-wide mt-2">
            <Link 
              to="/legal" 
              className="hover:text-koi-red transition-colors duration-300"
            >
              {t('nav.legal')}
            </Link>
            <span className="mx-2">•</span>
            <span>{t('info.madeBy')}</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;